import { Directive } from '@angular/core';
import { Validator, AbstractControl, ValidationErrors, NG_VALIDATORS } from '@angular/forms';

@Directive({
  selector: '[comparePasswordValidator]',
  providers: [{provide: NG_VALIDATORS, useExisting: ComparePasswordValidatorDirective, multi: true}]
})
export class ComparePasswordValidatorDirective implements Validator {

  constructor() { }

  validate(control: AbstractControl) : ValidationErrors | null{
    if(control.value.txtNewPassword != control.value.txtConfirmPassword){
      return {passwordDoNotMatch: { valid: false}};
    }else{
      return null;
    }
  }
}
